import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollToStory = () => {
    document.getElementById("story")?.scrollIntoView({
      behavior: "smooth"
    });
  };
  return <nav className="fixed top-0 left-0 right-0 p-3 z-50 bg-black/20 backdrop-blur-sm" data-id="element-54">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-55">
        <div data-id="element-56">
          <Link to="/" data-id="element-57">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/068640a2-5ba4-4dec-995b-f1241a0a916a/ejm_inspire_White_logo_(1).png" alt="EJM Inspire Logo" className="h-8 w-auto" data-id="element-58" />
          </Link>
        </div>
        <div className="hidden md:flex space-x-8" data-id="element-59">
          <a href="#story" onClick={e => {
          e.preventDefault();
          scrollToStory();
        }} className="text-white/80 hover:text-white" data-id="element-60">
            About
          </a>
          <Link to="/contact" className="text-white/80 hover:text-white" data-id="element-61">
            Contact
          </Link>
        </div>
        <button className="md:hidden text-white p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-62">
          {isMenuOpen ? <X size={24} data-id="element-63" /> : <Menu size={24} data-id="element-64" />}
        </button>
      </div>
      <AnimatePresence data-id="element-65">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-black/95 backdrop-blur-sm md:hidden" data-id="element-66">
            <div className="flex flex-col p-4 space-y-4" data-id="element-67">
              <a href="#story" className="text-white/80 hover:text-white text-lg py-2" onClick={() => {
            setIsMenuOpen(false);
            scrollToStory();
          }} data-id="element-68">
                About
              </a>
              <Link to="/contact" className="text-white/80 hover:text-white text-lg py-2" onClick={() => setIsMenuOpen(false)} data-id="element-69">
                Contact
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
};